import * as React from 'react';

import { SingleShadeWrapper, SingleShadeName } from './SingleShadeStyles';
import { MPP_SHADE_NAME } from '../../constants/DataTestIdAttributes';
import { ShadeIcon } from './ShadePickerCarousel';
import { ISingleShade } from '../../interfaces/IShadePicker';
import { classes } from '../../utils/Classes';

const SingleShadeWrapperClass = classes('single-shade-wrapper');

export const SingleShade = ({ selectedShade }: ISingleShade) => (
    <SingleShadeWrapper className={SingleShadeWrapperClass}>
        <ShadeIcon hexValue={selectedShade.hexVal} />
        <SingleShadeName data-test-id={MPP_SHADE_NAME}>{selectedShade.name}</SingleShadeName>
    </SingleShadeWrapper>
);
